export enum LegListRankType {
  ProfitAndLoss = 1,
  LoadFactor = 2,
}
